"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var CurrencySelector_1 = require("Project/Actions/ManualPageValue/CurrencySelector");
var AngularSyncStore_1 = __importDefault(require("@CommonFrontend/Utils/AngularSyncStore"));
var styles = __importStar(require("./CurrencyButton.css"));
var AngularController = (function () {
    function AngularController(mountReactComponent, currenciesUiDelegate, quoteContent, telemetry, block, projectStore, $rootScope, $timeout) {
        var _this = this;
        this.currenciesUiDelegate = currenciesUiDelegate;
        this.quoteContent = quoteContent;
        this.telemetry = telemetry;
        this.block = block;
        this.projectStore = projectStore;
        this.buttonName = function () {
            return "Currency";
        };
        this.onCurrencyChange = function (newCurrency) {
            _this.currenciesUiDelegate.setCurrency(_this.block, newCurrency);
            _this.quoteContent.forceRefreshViews(true);
            return _this.telemetry.trackOnly("Quote Block Currency Changed", {
                quote_block_currency_name: newCurrency,
            }, {
                blockIntercom: true,
            });
        };
        this.onLocaleChange = function (newLocale) {
            _this.projectStore.updateCurrencyLocale(newLocale);
        };
        var blockCurrencySyncStore = new BlockCurrencySyncStore(block, $rootScope, $timeout);
        this.ui = mountReactComponent(react_1.default.createElement(QuoteCurrencyButton, { blockCurrencySyncStore: blockCurrencySyncStore, projectStore: projectStore, onCurrencyChange: this.onCurrencyChange, onLocaleChange: this.onLocaleChange, disabled: block.$isSavedBlock }));
    }
    return AngularController;
}());
exports.default = AngularController;
var BlockCurrencySyncStore = (function (_super) {
    __extends(BlockCurrencySyncStore, _super);
    function BlockCurrencySyncStore(block, $rootScope, $timeout) {
        var _this = _super.call(this, block, { $scope: $rootScope, $timeout: $timeout }, {
            extractDataFromAngular: extractDataFromAngular,
            skipDiffOnAngularChange: true,
        }) || this;
        _this.block = block;
        _this.onAngularUpdated = function (newData) {
            _this._currency = newData.settings.currency;
        };
        _this.onAngularUpdated(extractDataFromAngular(block));
        return _this;
    }
    Object.defineProperty(BlockCurrencySyncStore.prototype, "currency", {
        get: function () {
            return this._currency;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlockCurrencySyncStore.prototype, "dataForAngular", {
        get: function () {
            return { settings: { currency: this.block.settings.currency } };
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], BlockCurrencySyncStore.prototype, "_currency", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockCurrencySyncStore.prototype, "onAngularUpdated", void 0);
    return BlockCurrencySyncStore;
}(AngularSyncStore_1.default));
function extractDataFromAngular(block) {
    var currency = block.settings.currency;
    return { settings: { currency: currency } };
}
var QuoteCurrencyButton = (0, mobx_react_1.observer)(function (_a) {
    var blockCurrencySyncStore = _a.blockCurrencySyncStore, projectStore = _a.projectStore, onCurrencyChange = _a.onCurrencyChange, onLocaleChange = _a.onLocaleChange, disabled = _a.disabled;
    var tooltipContent = disabled ? "Currency can't be selected in saved blocks" : "Currency";
    var tooltipSize = disabled ? kaleidoscope_1.TooltipSize.Large : kaleidoscope_1.TooltipSize.Small;
    var currencyLocale = projectStore.currencyLocale;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.positioningStack, justify: "center", align: "center" },
        react_1.default.createElement(CurrencySelector_1.CurrencySelector, { currentCurrency: blockCurrencySyncStore.currency, locale: currencyLocale, onChange: onCurrencyChange, disabled: disabled, iconOnly: true, buttonClassName: "".concat(styles.buttonSizeOverride, " ").concat(disabled ? styles.disabledButton : ""), tooltipProps: {
                content: tooltipContent,
                size: tooltipSize,
                position: kaleidoscope_1.TooltipPosition.Top,
                wrapTarget: true,
            }, bottomElement: react_1.default.createElement(LocaleSelector, { locale: currencyLocale, onLocaleChange: onLocaleChange }) })));
});
var DEFAULT_KEY = "default";
var LocaleSelector = function (_a) {
    var locale = _a.locale, onLocaleChange = _a.onLocaleChange;
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    if (!usingFeature(FeatureFlag_1.default.CurrencyLocales)) {
        return null;
    }
    function onChange(newLocale) {
        var transformedValue = newLocale === DEFAULT_KEY ? null : newLocale;
        onLocaleChange(transformedValue);
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", paddingTop: "xs" },
        react_1.default.createElement("div", { className: styles.horizontalDivider }),
        react_1.default.createElement(kaleidoscope_1.Select, { placeholder: "Select an option", label: "Formatting", value: locale !== null && locale !== void 0 ? locale : DEFAULT_KEY, onChange: onChange, autoStack: true },
            react_1.default.createElement(kaleidoscope_1.SelectOption, { value: DEFAULT_KEY }, "Default"),
            localesList.map(function (l) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { key: l.locale, value: l.locale }, l.displayName)); }))));
};
var localesList = [
    {
        locale: "en-IE",
        displayName: "English (Ireland)",
    },
    {
        locale: "en-GB",
        displayName: "English (United Kingdom)",
    },
    {
        locale: "en-DE",
        displayName: "English (Germany)",
    },
    {
        locale: "en-US",
        displayName: "English (United States)",
    },
].sort(function (a, b) {
    if (a.displayName < b.displayName)
        return -1;
    return 1;
});
